const transparentColorPattern = /^(transparent|rgba\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*,\s*0\s*\))$/

export function getEffectiveBackgroundColor(element: HTMLElement): string | null {
  let current: HTMLElement | null = element
  while (current) {
    const color = getComputedStyle(current).backgroundColor
    if (color && !transparentColorPattern.test(color)) {
      return color
    }
    current = current.parentElement
  }
  return null
}
